import FieldPriceController from './FieldPriceController'

export default FieldPriceController
